export type ElasticLang = 'da' | 'en' | 'de';

export const getElasticIndexName = (theme: Content.Theme, lang?: ElasticLang): string => {
	switch (theme) {
		case 'ADST':
			return 'adst-da';
		case 'FDS':
			return 'fds-da';
		case 'GAELDST':
			if (lang === 'da') return 'gaeldst-da';
			if (lang === 'en') return 'gaeldst-en';
			if (lang === 'de') return 'gaeldst-de';
			return 'gaeldst';
		case 'ITTI':
			return 'itti-da';
		case 'LOTTERIREGLER':
			return 'lotteriregler-da';
		case 'MOTORST':
			if (lang === 'da') return 'motorst-da';
			if (lang === 'en') return 'motorst-en';
			if (lang === 'de') return 'motorst-de';
			return 'motorst';
		case 'ROFUS':
			return 'rofus-da';
		case 'SANST':
			return 'sanst-da';
		case 'SKAT':
			if (lang === 'da') return 'skat-da';
			if (lang === 'en') return 'skat-en';
			if (lang === 'de') return 'skat-de';
			return 'skat'; // umbrella engine for multiple languages
		case 'SKM':
			return 'skm-da';
		case 'SKTFV':
			return 'sktfv-da';
		case 'SKTST':
			return 'sktst-da';
		case 'SPILLEMYNDIGHEDEN':
			return 'spillemyndigheden-da';
		case 'STOPSPILLET':
			return 'stopspillet-da';
		case 'STYRPAASPILLET':
			return 'styrpaaspillet-da';
		case 'TOLDST':
			if (lang === 'da') return 'toldst-da';
			if (lang === 'en') return 'toldst-en';
			if (lang === 'de') return 'toldst-de';
			return 'toldst';
		case 'UFST':
			return 'ufst-da';
		case 'VURDST':
			if (lang === 'da') return 'vurdst-da';
			if (lang === 'en') return 'vurdst-en';
			if (lang === 'de') return 'vurdst-de';
			return 'vurdst';
		case 'WEBGUIDE':
			return 'webguide-da';
		case 'ZISE':
			return 'zise-da';
	}
};
